import React from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { postApiService } from "../services/ApiService";
import { SetPayLoad } from "../services/PayLoadStorage";
import { useAuth } from "../contexts/AuthContext";
import { useEffect, useState } from "react";
import { toast } from 'react-toastify';
import { decryptResponseData } from '../services/EncryptService'; // encrypt/decrypt request response handling - st48236
import Cookies from 'js-cookie';
import { getCookieOptions } from '../utils/cookieUtils';
import { getLoginFromFlag, setConnectiCareCarrier } from "../utils/findLoginSource";

const SSOMemberCheck = () => {

    const [searchParams] = useSearchParams();
    const dataKey = searchParams.get('dataKey');
    
    const { setAuthData } = useAuth();
    const navigate = useNavigate();
    const [isLoading, setLoading] = useState(true); // State to track loading status


    const handleMultipleIlbLogin = (result) => {
        
        if(result?.multipleIlb !== undefined){
            const multipleIlb = result?.multipleIlb;
            const activeCases = multipleIlb?.activeCases || [];
            //set carrier code and state code to identify ConnectiCare carrier with active cases for multiple ILB scenario
            let carrierCode = result?.[0]?.owning_carrier?.toUpperCase() || null;
            let stateCode = result?.[0]?.state || null;  
            let cim = result?.[0]?.cim || null; // Assuming CIM is also needed based on previous code context          
            let resultValue = carrierCode+stateCode;
            let isConnectiCareCarrier = false;
            let connectiCareCarrier = null;
            if(activeCases !== ''){
                //Set the active cases to session storage
                SetPayLoad('ActiveCases', btoa(JSON.stringify(activeCases)));
                localStorage.setItem('multipleILB', 'true');
                if(resultValue === process.env.REACT_APP_CONNECTICARE_CARRIER_CODE){
                    isConnectiCareCarrier = true;
                    connectiCareCarrier = process.env.REACT_APP_CONNECTICARE_CARRIER_CODE;
                }
                Cookies.set('isConnectiCareCarrier', isConnectiCareCarrier, getCookieOptions());
                sessionStorage.setItem('stateCode', stateCode); // Set state code in session storage for ConnectiCare carriers
                sessionStorage.setItem('cimNumber', cim); // Set CIM in session storage for ConnectiCare carriers
                if(isConnectiCareCarrier){
                    Cookies.set('connectiCareCarrier', connectiCareCarrier, getCookieOptions());
                }
                //set carrier code and state code to identify ConnectiCare carrier with active cases for multiple ILB scenario
            }
        }
    }
 
    useEffect(() => {
        const urlDataKey = dataKey ? decodeURIComponent(dataKey) : null; 
        if(urlDataKey){
            decryptResponseData(urlDataKey)
            .then(async (dataKey) => {
                setTimeout(async () => {
                    if(dataKey){
                        const decodedDataKey = dataKey ? btoa(dataKey) : null; 
                        const parsedData = JSON.parse(atob(decodedDataKey));
                        
                        // Wait for loginFrom flag to be retrieved
                        //const flags = await getLoginFromFlag(parsedData);
                        // if loginFrom is empty, set default false
                        //const normalizeFlag = (val) => Array.isArray(val) ? (val.length > 0 ? val : false) : val || false;
                        //const retrievedLoginFromFlag = normalizeFlag(flags.loginFrom);
                        //const retrievedRegionFlag = normalizeFlag(flags.region);
                        
                        const payload = new FormData();
                        const baseUrl = process.env.REACT_APP_API_BASE_URL;
                        const headers = {
                                            "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
                                            "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
                                        };
                        const targetLoginUrl = process.env.REACT_APP_API_LOGIN_ENDPOINT;
            
                        //Customize site_cd based on carrier_code
                        if(parsedData?.carrier_code === 'J1'){
                            payload.append("site_cd", 'CGMBR');
                        }else{
                            payload.append("site_cd", parsedData?.carrier_code+'MBR');
                        }
            
                        // Set region based on cookies or environment variable
                        const selectedRegion = Cookies.get('region');
                        if(selectedRegion !== null && selectedRegion !== undefined && selectedRegion !== ''){
                            payload.append("region", selectedRegion);
                        }else{
                            // if no region cookie is set, use environment variable
                            if(process.env.REACT_APP_ENVIRONMENT === 'PROD'){
                                payload.append("region", process.env.REACT_APP_PROD_DB2_REGION);
                                Cookies.set('region', process.env.REACT_APP_PROD_DB2_REGION, getCookieOptions());
                            }else if(process.env.REACT_APP_ENVIRONMENT === 'PFIX'){
                                payload.append("region", process.env.REACT_APP_PFIX_DB2_REGION);
                                Cookies.set('region', process.env.REACT_APP_PFIX_DB2_REGION, getCookieOptions());
                            }else{
                                // Default to DB2J.<environment> if no region is set
                                payload.append("region", 'DB2J.'+process.env.REACT_APP_ENVIRONMENT);
                                Cookies.set('region', 'DB2J.'+process.env.REACT_APP_ENVIRONMENT, getCookieOptions());
                            }
                        }
            
                        payload.append("memberid", parsedData?.member_profile_id);
                        payload.append("ssn", parsedData?.SSN || '');
                        payload.append("dob", parsedData?.dob);
                        payload.append("zip", parsedData?.zip_code || '');
                        payload.append("carrier", parsedData?.carrier_code.toUpperCase());
                        payload.append("userid", parsedData?.userid || '');
            
                        postApiService(
                            baseUrl, 
                            targetLoginUrl,
                            payload,
                            headers
                        ).then((result) =>{
                            if(result?.data?.statusCode === 200){
                                const response = result.data.data;
                                if(response?.LoginStatus === true){
                                    const res = JSON.parse(atob(response?.MemberPayload));
                                    if(res?.multipleIlb !== undefined){
                                        handleMultipleIlbLogin(res);
                                    }

                                    setAuthData(response?.MemberPayload);
                                    const IsMultipleIlb = localStorage.getItem('multipleILB') || 'false';

                                    if(IsMultipleIlb !== 'true'){ 
                                        SetPayLoad('PayLoad', response?.MemberPayload);
                                        setConnectiCareCarrier(); // Set ConnectiCare carrier cookies if applicable
                                    }

                                    // Set owningCarrier cookie from SSO data (handle J1 special case)
                                    let carrierCode = parsedData?.carrier_code.toUpperCase();
                                    if(parsedData?.carrier_code === 'J1'){
                                        carrierCode = 'CG'; // J1 maps to CG
                                    }
                                    Cookies.set('owningCarrier', carrierCode, getCookieOptions());
                                    
                                    const defaultLang = res?.defaultLang;                                    
                                    if(defaultLang !== '' && defaultLang === 'SPANISH'){
                                        Cookies.set('lang', 'spa', getCookieOptions());
                                    }

                                    // Check login from flag exists in session storage, if not set to Carrier as default
                                    if(!sessionStorage.getItem('loginFrom')){
                                        sessionStorage.setItem('loginFrom', 'Carrier');
                                    }

                                    setLoading(false);
                                    // Redirect based on whether the member has multiple ILB or not
                                    if(IsMultipleIlb === 'true'){
                                        navigate('/landing');
                                    }else{
                                        navigate("/overview");
                                    }
                                }else{
                                    handleMemberLoginErr();
                                }
                            }else{
                                handleMemberLoginErr();
                            }       
                        }).catch(error => {
                            console.error('Error fetching data:', error);
                        });
                    }
                }, 1000); // Delay to simulate loading state
            })
            .catch((error) => {
                console.error("Error decrypting dataKey:", error);
            });
        }       
        
    }, []);
    
    // Function to handle member login error
    const handleMemberLoginErr = () => {
        setLoading(false);
        toast.error('Invalid member data, Please try again with valid data.');
        // Check login from flag exists in cookies, if not set to Carrier as default, 
        // This is to handle the scenario when SSO check API fails to return loginFrom flag
        const loginFromFlag = sessionStorage.getItem('loginFrom') || 'Carrier';
        sessionStorage.setItem('loginFrom', loginFromFlag);
        setTimeout(() => {
            window.location.href = '/logout'; // Redirect to logout if login fails, this will clear cookies
        }, 1000);
    }

    return (
        <div>
            {isLoading && (
            <div className="container">
                <div className="row">
                    <div className="col-12 text-center">
                        <h1 className="mt-5">Redirecting...</h1>
                        <p>Please wait while we redirect you to the appropriate page.</p>
                    </div>
                </div>
            </div>
            )}

        </div>
    );
};

export default SSOMemberCheck;
